export default __webpack_public_path__ + "static/media/coleta-mujer-negro.441253c0.png";